// src/pages/admin/AddUser.jsx
import { useState, useContext } from "react";
import {
  Box,
  Heading,
  Input,
  Button,
  VStack,
  Field,
} from "@chakra-ui/react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import AuthContext from "../../context/AuthContext";
import { toaster } from "../../components/ui/toaster";

export default function AddUser() {
  const { user: currentUser } = useContext(AuthContext);
  const navigate = useNavigate();

const [form, setForm] = useState({
  firstName: "",
  lastName: "",
  email: "",
  password: "",
});

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async () => {
    if (!form.firstName || !form.lastName || !form.email || !form.password){
      toaster.create({
        title: "Bitte alle Felder ausfüllen",
        type: "warning",
      });
      return;
    }

    try {
      await axios.post(
        `${process.env.REACT_APP_API_URL}/api/users`,
        {
          ...form,
          role: "ROLE_USER",
          adminLevel: "NORMAL",
        },
        {
          headers: {
            Authorization: `Bearer ${currentUser.token}`,
          },
        }
      );

      toaster.create({
        title: "Benutzer erfolgreich angelegt",
        type: "success",
      });

      navigate("/admin/benutzerverwaltung");
    } catch (err) {
      toaster.create({
        title: "Fehler beim Anlegen",
        description: err.response?.data || "Serverfehler",
        type: "error",
      });
    }
  };

  return (
    <Box maxW="lg" mx="auto" mt={10} p={8} bg="white" borderRadius="xl" boxShadow="lg">
      <Heading size="md" mb={6}>
        Benutzer anlegen
      </Heading>

      <VStack spacing={4}>
        <Field.Root>
          <Field.Label>Vorname</Field.Label>
          <Input
            name="firstName"
            value={form.firstName}
            onChange={handleChange}
            placeholder="Vorname"
          />
        </Field.Root>

        <Field.Root>
          <Field.Label>Nachname</Field.Label>
          <Input
            name="lastName"
            value={form.lastName}
            onChange={handleChange}
            placeholder="Nachname"
          />
        </Field.Root>

        <Field.Root>
          <Field.Label>E-Mail</Field.Label>
          <Input
            name="email"
            type="email"
            value={form.email}
            onChange={handleChange}
            placeholder="email@envaris.de"
          />
        </Field.Root>

        <Field.Root>
  <Field.Label>Passwort</Field.Label>
  <Input
    name="password"
    type="password"
    value={form.password}
    onChange={handleChange}
    placeholder="Passwort"
  />
</Field.Root>

        <Button colorScheme="blue" w="full" mt={4} onClick={handleSubmit}>
          Speichern
        </Button>

        <Button variant="ghost" w="full" onClick={() => navigate("/admin/benutzerverwaltung")}>
          Abbrechen
        </Button>
      </VStack>
    </Box>
  );
}